<section>
  <div *ngIf="!isCartLoaded$.value || !isCharityLoaded$.value || isLoadingClearPays" class="container">
    <div class="row">
      <div class="row ml-2 pt-1">
        <div class="col-4 col-sm-4 col-md-3 m-1">
          <ngx-skeleton-loader
            count="1"
            [theme]="{
              'height.px': 40,
              'background-color': '#e4e4e4'
            }"
            [animation]="false"
          ></ngx-skeleton-loader>
        </div>
      </div>
      <div class="row ml-2 pt-1">
        <div class="col-5 col-sm-5 col-md-4 m-1">
          <ngx-skeleton-loader
            count="1"
            [theme]="{
              'height.px': 60,
              'background-color': '#e4e4e4'
            }"
            [animation]="false"
          ></ngx-skeleton-loader>
        </div>
      </div>
      <div class="row p-8">
        <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6">
          <ngx-skeleton-loader
            [theme]="{
              'height.px': 60,
              'background-color': '#e4e4e4'
            }"
            [animation]="false"
          ></ngx-skeleton-loader>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6">
          <ngx-skeleton-loader
            [theme]="{
              'height.px': 60,
              'background-color': '#e4e4e4'
            }"
            [animation]="false"
          ></ngx-skeleton-loader>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6">
          <ngx-skeleton-loader
            [theme]="{
              'height.px': 60,
              'background-color': '#e4e4e4'
            }"
            [animation]="false"
          ></ngx-skeleton-loader>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6">
          <ngx-skeleton-loader
            [theme]="{
              'height.px': 60,
              'background-color': '#e4e4e4'
            }"
            [animation]="false"
          ></ngx-skeleton-loader>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6">
          <ngx-skeleton-loader
            [theme]="{
              'height.px': 60,
              'background-color': '#e4e4e4'
            }"
            [animation]="false"
          ></ngx-skeleton-loader>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6">
          <ngx-skeleton-loader
            [theme]="{
              'height.px': 60,
              'background-color': '#e4e4e4'
            }"
            [animation]="false"
          ></ngx-skeleton-loader>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6">
          <ngx-skeleton-loader
            [theme]="{
              'height.px': 60,
              'background-color': '#e4e4e4'
            }"
            [animation]="false"
          ></ngx-skeleton-loader>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6">
          <ngx-skeleton-loader
            [theme]="{
              'height.px': 60,
              'background-color': '#e4e4e4'
            }"
            [animation]="false"
          ></ngx-skeleton-loader>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6">
          <ngx-skeleton-loader
            [theme]="{
              'height.px': 60,
              'background-color': '#e4e4e4'
            }"
            [animation]="false"
          ></ngx-skeleton-loader>
        </div>
      </div>
      <div class="row p-8">
        <div class="col-md-3">
          <ngx-skeleton-loader
            count="1"
            [theme]="{
              'height.px': 50,
              'background-color': '#e4e4e4'
            }"
            [animation]="false"
          ></ngx-skeleton-loader>
        </div>
        <div class="col-md-3">
          <ngx-skeleton-loader
            count="1"
            [theme]="{
              'height.px': 50,
              'background-color': '#e4e4e4'
            }"
            [animation]="false"
          ></ngx-skeleton-loader>
        </div>
        <div class="col-md-3">
          <ngx-skeleton-loader
            count="1"
            [theme]="{
              'height.px': 50,
              'background-color': '#e4e4e4'
            }"
            [animation]="false"
          ></ngx-skeleton-loader>
        </div>
        <div class="col-md-3">
          <ngx-skeleton-loader
            count="1"
            [theme]="{
              'height.px': 50,
              'background-color': '#e4e4e4'
            }"
            [animation]="false"
          ></ngx-skeleton-loader>
        </div>
      </div>
      <div class="row d-flex justify-content-center">
        <div class="col-10 col-sm-10 col-md-9 m-1">
          <ngx-skeleton-loader
            count="1"
            [theme]="{
              'height.px': 50,
              'background-color': '#e4e4e4'
            }"
            [animation]="false"
          ></ngx-skeleton-loader>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="(this.isCartLoaded$  | async )&& (isCharityLoaded$ | async)">
    <div class="col-lg-8">
      <ea-order-steps *ngIf="!orderId" [step]="'Payment'"></ea-order-steps>
    </div>

    <div class="row contint" *ngIf="!orderId">
      <div class="col-lg-8">
        <div class="col-lg-12">
          <div class="pt-3">
              <ea-checkout-addresses
               class="w-100"
                [isBulling]="true"
                [bullingAddress]="bullingAddress"
                [newBillingAddress]="newBullingAddress"
                (changes)="changeAddress($event)"
              >
              </ea-checkout-addresses>
              <br class="space">
            <ea-charity-choose
              [charities]="charities"
              [disability]="disability"
              [user]="user"
              [selectedDedisability]="selectedDedisability"
              [selected]="selected"
              (changeDisabilityEvent)="changeDisability($event)"
              (onOptionsChangedEvent)="onOptionsChanged($event)"
            ></ea-charity-choose>
            <br class="space">


            <div>
              <div
                class="p-4 bg-theme-surface text-theme-on-surface mb-3 font-title mb-4 address-card cart-div"

              >
              <hr class="mobile">

                <h1 class="font-bold">Your saved payment cards</h1>
                <div
                  *ngFor="let option of cards"
                  [ngClass]="
                    option != slectdCardoption
                      ? 'col address-option'
                      : 'col address-option div-active'
                  "
                >
                  <div class="contaner justify-content-between row">
                    <div class="col-1 mt-2">
                      <label>
                        <input
                          class="form-radio-input"
                          type="radio"
                          [(ngModel)]="slectdCardoption"
                          [value]="option"
                          name="card"
                          (click)="selectedCardId(option)"
                          id="{{option.paymentMethodId}}"
                        />
                      </label>
                    </div>
                    <div class="col-7 justify-content-between row">
                      <div class="col-lg-3">
                        <img
                          data-src="assets/images/cardsIcons/{{
                            option.type
                          }}.png"
                          style="width: 90px"
                          alt="Card Type"
                        />
                      </div>
                      <div class="col-lg-9 font-bold type">
                        <h2>
                          {{ option.type }}
                        </h2>
                      </div>
                    </div>
                    <div class="col-4">
                      <h2><label for="{{option.paymentMethodId}}">**** - {{ option.last4 }}</label></h2>
                    </div>
                  </div>
                </div>
                <div
                [ngClass]="selectedPaymentMethod === 'newCard' && !isClearPay
                  ? 'col address-option div-active'
                  : 'col address-option'"
              >
                <div class="contaner justify-content-between row">
                  <div class="col-1 mt-3">
                    <label>
                      <input
                        class="form-radio-input"
                        type="radio"
                        [(ngModel)]="selectedPaymentMethod"
                        name="card"
                        (click)="show(false)"
                        [value]="'newCard'"
                        id="newCard"
                      />
                    </label>
                  </div>
                  <div class="col-11">
                    <h2 class="m-0">
                      <label for="newCard" class="ml-2">Add a new credit/debit card</label>
                    </h2>
                  </div>
                </div>
              </div>
              
              <form
              [formGroup]="form"
              class="mt-4"
              (ngSubmit)="makePayment()"
              *ngIf="(!thereAreCards || displayNewCard) && !isClearPay"
            >
       
              <div>
                <h1 class="font-bold">Enter new payment card details</h1>
                <div *ngIf="!thereAreCards || displayNewCard">
                  <div class="row w-100">
                    <div class="col-10">
                      <ea-form-field
                        class="form-field col-sm-12 col-md-3 d-flex justify-content-between align-items-between flex-column w-100 row"
                        label="Card Number"
                        name="cardNumber"
                        alt="Card Number input"
                        [form]="form"
                      ></ea-form-field>
                    </div>
                    <div class="col-2 mt-4">
                      <img
                        src="assets/images/cardsIcons/cardNumberIcon.svg"
                        style="width: 60px; margin-top: 30px"
                        alt="Card number"
                      />
                    </div>
                  </div>
                  <div class="row w-100">
                    <div class="col-10">
                      <ea-form-field
                        class="form-field col-sm-12 col-md-3 d-flex justify-content-between align-items-between flex-column row w-100"
                        label="Expiry date MM/YY"
                        name="expiryMonth"
                        alt="Expiry Month input"
                        [form]="form"
                        [expiredDate]="true"
                      ></ea-form-field>
                    </div>
                    <div class="col-2 mt-4">
                      <img
                        src="assets/images/cardsIcons/cardExpiryDate.svg"
                        style="width: 60px; margin-top: 30px"
                        alt="Card number"
                      />
                    </div>
                  </div>
                  <div class="row w-100">
                    <div class="col-10">
                      <ea-form-field
                        class="form-field col-sm-12 col-md-3 d-flex justify-content-between align-items-between flex-column row w-100"
                        label="CVC"
                        name="cvc"
                        alt="cvc input"
                        [form]="form"
                      ></ea-form-field>
                    </div>
                    <div class="col-2 mt-4">
                      <img
                        src="assets/images/cardsIcons/CVC.svg"
                        style="width: 60px; margin-top: 30px"
                        alt="Card number"
                      />
                    </div>
                  </div>
                  <div class="row w-100">
                    <div class="col-12">
                      <ea-form-field
                        class="form-field col-sm-12 col-md-3 d-flex justify-content-between align-items-between flex-column row w-100"
                        label="Name on card"
                        name="fullName"
                        alt="Name on card"
                        [form]="form"
                      ></ea-form-field>
                    </div>
                  </div>
                </div>
                <div
                  class="mt-3 text-right"
                  *ngIf="!thereAreCards || displayNewCard"
                >
                  <input
                    type="checkbox"
                    class="form-check-input focus-ring"
                    [checked]="saveCart"
                    style="width: 20px; height: 20px"
                    (change)="saveCart = !saveCart"
                    aria-label="Remember me"
                    alt="save card checkbox"
                  />
                  <label style="margin-top: -15px; margin-left: 5px;"> Save card</label>
                </div>
              </div>
       
              <br>
              <hr>
            </form>
              <div
              *ngIf="totalAmount! <= 1400"
                [ngClass]="selectedPaymentMethod === 'clearPay' ? 'col address-option div-active' : 'col address-option'"
              >
                <div class="contaner justify-content-between row" >
                  <div class="col-1 mt-2">
                    <label>
                      <input
                        class="form-radio-input"
                        type="radio"
                        [(ngModel)]="selectedPaymentMethod"
                        name="card"
                        (click)="show(true)"
                        [value]="'clearPay'"
                        id="isClearPay"
                      />
                    </label>
                  </div>
                  <div class="col-11 justify-content-between row">
                    <h2>
                      <label for="isClearPay" style="display: inline-flex; ">
       
                        <img alt="clearpay-logo" class="clearpay-logo" src="assets/images/clearpay-logo-blackmint.png"  />
                        Clearpay  
                    </label>
                    
                    </h2>
                  </div>
                </div>
              </div>
              <br>              <br>
              <div *ngIf="isClearPay">
                <div class="row w-100">
                  <div class="col-12">
                    <span>Clearpay is a buy now, pay later service that allows customers to split their purchases into four interest-free instalments. Late pay charges will apply to instalments not paid on time.</span> <br>
                    <label for="email" class="ea-label form-label">
                      Email <span class="required" >(Required)</span>
                    </label>
                    <input
                      type="text"
                      class="ea-input w-100 focus-ring"
                      id="email"
                      [(ngModel)]="clearPayEmail"
                      placeholder="email"
                      alt = 'email'
                    />
                  </div>
                  </div>
                  <br>
              </div>
    
              <div class="row">
                <div>
                  <ng-container *ngIf="error$ | async as error">
                    <div class="error text-red-500 font-bold">
                      {{ error }}
                    </div>
                  </ng-container>
      
                </div>
              </div>
                <button
                (click)="makePayment()"
                title="Pay now"
                value="Pay now"
                class="ea-button ea-button-primary col-lg-12 col-xl-12 focus-ring w-100"
                [disabled]="form.invalid || (isLoading$ | async) || (isClearPay && !clearPayEmail)"
                *ngIf="cart"
              >
              <span class="material-icons mt-1 mr-1">lock</span>
              <p class="text-theme-on-surface" style="color: white;">
              <strong>Pay {{ totalAmount | currency: cart.currency }} now </strong>
              </p>
              </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-4 justify-content-end discktop">
        <div class="subtotal-content">
          <div
          class="total-card"
        >
          <div class="row ps-2 pe-2 cart-totals">
            <div *ngIf="cart">
              <div class="row">
                <div class="col-lg-8">Subtotal</div>

                <div class="col-lg-4">
                  <div
                    class="float-right mb-3 text-right"
                  >
                    <p class="text-theme-on-surface">
                      {{
                        cart.subTotal - estimatedShippingAmount
                          | currency: cart.currency
                      }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-8">Estimated shipping</div>

                <div class="col-lg-4" >
                  <div class="float-right text-theme-on-surface mb-3 text-right">
                  <p class="text-theme-on-surface">  {{ estimatedShippingAmount | currency: cart.currency }}</p>
                  </div>
                </div>
              </div>
              <hr *ngIf="cart.allPromosApplied" class="text-light-gray" />
              <div class="row">
                <div class="col-lg-8"><strong  *ngIf=" cart.allPromosApplied"><span>Promotion applied</span></strong></div>
                <div class="col-lg-4">
                  <tr class="savings"  *ngIf=" cart.allPromosApplied">

                      <button
                        class="remove-btn"
                        (click)="removePromo()"
                      >
                        <mat-icon>close</mat-icon> Remove
                      </button> 
                
                </div>
              </div>

              <div class="row"  *ngIf="cart.allPromosApplied">
                <div class="col-lg-8">      <span *ngFor="let p of cart.allPromosApplied;  let i = index">
                  @if(p.promoCode){
                  {{p.promoCode}} 
                  }
                 @else{
                    {{cart.promotionMessages[0].message}}
                  }
                  @if(i != cart.allPromosApplied.length -1){
                    -
                  }
                </span></div>

                <div class="col-lg-4" >
                  <div class="float-right text-theme-on-surface mb-3 text-right">
                  <p class="text-theme-on-surface"> - {{ cart.totalDiscount | currency: cart.currency }}</p>
                  </div>
                </div>
              </div>
              <hr class="text-light-gray" />
              <div class="row mt-1">
                <div class="col-lg-8">
                  <strong>Total to pay</strong>
                </div>
                <div class="col-lg-4">
                  <div class="float-right mb-3 text-right">
                    <p class="text-theme-on-surface font-bold">
                      {{ cart.totalAmount | currency: cart.currency }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-8">VAT</div>
                <div class="col-lg-4">
                  <div class="float-right mb-3 text-right">
                    <p class="text-theme-on-surface">
                      {{ totalTax | currency: cart.currency }}
                    </p>
                  </div>
                </div>
              </div>

              <ng-container *ngIf="error$ | async as error">
                <div class="error text-red-500 font-bold">{{ error }}</div>
              </ng-container>
              <button
                type="submit"
                title="Pay now"
                value="Pay now"
                (click)="makePayment()"
                class="ea-button ea-button-primary col-sm-12 col-md-12 col-lg-12 col-xl-12 focus-ring"
                [disabled]="form.invalid || (isLoading$ | async) || (isClearPay && !clearPayEmail)"
              >
                <span class="material-icons mt-1 mr-1">lock</span>
              <p class="text-theme-on-surface" style="color: white;">
             <strong> Pay {{ totalAmount | currency: cart.currency }} now </strong>
              </p>
              </button>
            </div>
            </div>
          </div>
          <div class="promo-content d-none d-md-block col-lg-12 mt-4">
            <ng-container *ngIf=" cart ">
              <ng-container *ngIf="cart.totalItems > 0 ">
                <div
                  class="total-card"
                >
                  <div class="row ps-2 pe-2 cart-totals">
                  
                 <label><strong><span>Apply a promotion</span></strong></label>
                 <input class="input-text" type="text" placeholder="Promotion code or coupon" [(ngModel)]="promo">
                  </div>
                  <div class="row ps-3 pe-3 mt-4">
                    <ng-container *ngIf="this.cartService.toast">
                      <div class="error text-red-500 font-bold" *ngIf="this.cartService.toast.message !='Promotion applied successfully!'">        {{this.cartService.toast.message}}</div>
                    </ng-container>
            
                    <button
                      (click)="applyPromoCode(cart)"
                      class="ea-button ea-button-primary  w-100 p-1 font-title font-bold"
                      [disabled]="!promo || (isButtonsDisabled$ | async)"
                    >
                     Apply
                    </button>
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </div>

          <div style="margin-top: 65px;">
            <ea-info-card></ea-info-card>
          </div>

        </div>



      </div>

      <div class="subtotal-content-mobile col-lg-12">
        <div >
          <div *ngIf="cart">
            <div class="row mt-1">
              <div class="col-7">Subtotal</div>

              <div class="col-4">
                <div
                  class="float-right text-right"
                  *ngIf="estimatedShippingAmount > 0"
                >
                  <p class="text-theme-on-surface">
                    {{
                      cart.subTotal - estimatedShippingAmount
                        | currency: cart.currency
                    }}
                  </p>
                </div>
              </div>
            </div>
            <div class="row mt-1">
              <div class="col-7">Estimated Delivery</div>

              <div class="col-4" *ngIf="estimatedShippingAmount">
                <div class="float-right text-right">
                  {{ estimatedShippingAmount | currency: cart.currency }}
                </div>
              </div>
            </div>
            <hr *ngIf="cart.allPromosApplied" class="text-light-gray" />
        

            <div class="row mt-1" *ngIf="cart.allPromosApplied">
              <div class="col-7">
                <strong>Promotion applied</strong>
              </div>
              <div class="col-5 float-right text-right"  *ngIf=" cart.allPromosApplied">

                    <button
                      class="remove-btn"
                      (click)="removePromo()"
                    >
                      <mat-icon>close</mat-icon> Remove
                    </button> 
              
              </div>
            </div>
        

            <div class="row mt-1" *ngIf="cart.allPromosApplied">
              <div class="col-7">
                <strong  *ngFor="let p of cart.allPromosApplied;  let i = index"> @if(p.promoCode){
                  {{p.promoCode}} 
                  }
                 @else{
                    {{cart.promotionMessages[0].message}}
                  }
                  @if(i != cart.allPromosApplied.length -1){
                    -
                  }</strong>
              </div>
              <div class="col-4">
                <div class="float-right text-right">
                  <p class="text-theme-on-surface font-bold">
                    - {{ cart.totalDiscount | currency: cart.currency }}
                  </p>
                </div>
              </div>
            </div>
            <div>
              <button  (click)="triggerPromoCode()" class="remove-btn"><u>Apply a promotion <mat-icon>arrow_drop_down</mat-icon>
              </u> </button> 
              <div *ngIf="showPromoCode">
                 <ng-container *ngIf="cart$ | async as cart ">
                   <ng-container *ngIf="cart.totalItems > 0 ">
                       <div
                         class="total-card mobile-view mobile"
                         style="width: 90%;"
                       >
                         <div class="row ps-2 pe-2 cart-totals">
                         
                        <input class="input-text" type="text" placeholder="Promotion code or coupon" [(ngModel)]="promo">
                         </div>
                         <div class="row ps-3 pe-3 mt-4">
                          <ng-container *ngIf="this.cartService.toast">
                            <div class="error text-red-500 font-bold" *ngIf="this.cartService.toast.message !='Promotion applied successfully!'">        {{this.cartService.toast.message}}</div>
                          </ng-container>
                           <button
                             (click)="applyPromoCode(cart)"
                             class="ea-button ea-button-primary  w-100 p-1 font-title font-bold"
                             [disabled]="!promo || (isButtonsDisabled$ | async)"
                           >
                            Apply
                           </button>
                         </div>
                       </div>
                  </ng-container>
                  </ng-container>
                 </div>
             </div>
            <hr class="text-light-gray" />
            <div class="row mt-1">
              <div class="col-7">
                <strong>Total to pay</strong>
              </div>
              <div class="col-4">
                <div class="float-right text-right">
                  <p class="text-theme-on-surface font-bold">
                    {{ cart.totalAmount | currency: cart.currency }}
                  </p>
                </div>
              </div>
            </div>
            <div class="row mt-1">
              <div class="col-7">VAT</div>
              <div class="col-4">
                <div class="float-righ text-right">
                  <p class="text-theme-on-surface">
                    {{ totalTax | currency: cart.currency }}
                  </p>
                </div>
              </div>
            </div>

            <ng-container *ngIf="error$ | async as error">
              <div class="error text-red-500 font-bold">{{ error }}</div>
            </ng-container>

            <div class="d-flex justify-content-center mt-4">
            <button
            style="width: 70%;"
              type="submit"
              title="Pay now"
              value="Pay now"
              (click)="makePayment()"
              class="ea-button ea-button-primary col-12 focus-ring"
              [disabled]="form.invalid || (isLoading$ | async) || (isClearPay && !clearPayEmail)"
            >
              <span class="material-icons mt-1 mr-1">lock</span>
              <p class="text-theme-on-surface" style="color: white;">
                <strong> Pay {{ totalAmount | currency: cart.currency }} now</strong>
              </p>
            </button>
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</section>
